import { render, staticRenderFns } from "./TagsComponent.vue?vue&type=template&id=015ad5ff"
import script from "./TagsComponent.vue?vue&type=script&lang=js"
export * from "./TagsComponent.vue?vue&type=script&lang=js"
import style0 from "./TagsComponent.vue?vue&type=style&index=0&id=015ad5ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports